module.exports = __webpack_public_path__ + "img/xia.b2298111.svg";